import { Injectable } from '@angular/core';
import { AlertController, ModalController } from '@ionic/angular';
import { AlertOptions, ComponentRef, ModalOptions } from '@ionic/core';
import { TranslateService } from '@ngx-translate/core';
import { assign } from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  get defaultOptions(): AlertOptions {
    return {
      cssClass: 'toro-alert',
    }
  }

  get defaultModalOptions(): ModalOptions<ComponentRef> {
    return {
      component: null,
      cssClass: 'toro-modal'
    }
  }

  constructor(
    private alertController: AlertController,
    private modalController: ModalController,
    private translate: TranslateService
  ) { }

  createAlert(options: AlertOptions) {
    const opts = this.defaultOptions;
    assign(opts, options);
    return this.alertController.create(opts);
  }

  /**
   * The cancel handler is called when backdrop role is triggered
   * TODO add destructive role
   * @param cancelHandler
   * @param confirmHandler
   * @returns
   */
  createConfirmDeleteAlert(cancelHandler: { (): boolean; }, confirmHandler: { (): boolean; }, display?: string) {
    return this.createAlert({
      header: `${this.translate.instant('PROMPT_MESSAGE_DELETE_TITLE')}`,
      message: `<strong> ${this.translate.instant('PROMPT_MESSAGE_DELETE_BODY')} this${display != null ? ' ' + this.translate.instant(display) : ''}, ${this.translate.instant('PROMPT_MESSAGE_DELETE_BODY_SUFFIX')}</i>?<strong>`,
      buttons: [{
        text: this.translate.instant('Actions_Cancel'),
        role: 'cancel',
        cssClass: 'secondary button-outline',
        handler: cancelHandler
      }, {
        text: this.translate.instant('Actions_Delete'),
        cssClass: 'danger button-outline',
        handler: confirmHandler
      }]
    });
  }

  createModal(options: ModalOptions<ComponentRef>) {
    const opts = this.defaultModalOptions;
    assign(opts, options);
    if (opts.component === null) {
      console.error('Failed to pass component ref to createModal');
    }
    return this.modalController.create(opts)
  }

  /**
   *
   * @returns
   */
  async dismissAllAlerts(status = false): Promise<boolean> {
    const current = await this.alertController.getTop();
    if (current == null) { return Promise.resolve(true); }
    return this.alertController.dismiss({ status: status }).then(() => this.dismissAllAlerts());
  }

  async dismissDialog(options?: any): Promise<boolean> {
    const current = await this.modalController.getTop();
    if (current == null) { return Promise.resolve(true); }
    const response = assign({ status: false }, options);
    return this.modalController.dismiss(response);
  }

  /**
   *
   * @returns
   */
  async dismissAllDialogs(): Promise<boolean> {
    const current = await this.modalController.getTop();
    if (current == null) { return Promise.resolve(true); }
    return this.modalController.dismiss({ status: false }).then(() => this.dismissAllDialogs());
  }
}
